/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ILayoutConfig, LAYOUT_TABS_STYLE, LAYOUT_TYPE } from "../../../ui/components/Layout/LayoutTypes";
import { ARROW_POSITION } from "../../../ui/components/Toolbar/Toolbar";

export const EndpointEditorEditLayoutConfig: ILayoutConfig = {
	root: {
		type: LAYOUT_TYPE.ROW,
		id: "layout",
		children: [
			{
				type: LAYOUT_TYPE.COLUMN,
				id: "panelLeft",
				size: "250px",
				isExpandable: true,
				defaultExpanded: true,
				children: [
					{
						type: LAYOUT_TYPE.PANEL,
						id: "outline",
						isExpandable: true,
						size: 40,
						arrowPosition: ARROW_POSITION.LEFT,
						toolbarComponent: "outlineToolbar",
						contentComponent: "outlineContent"
					},
					{
						type: LAYOUT_TYPE.SPLITTER,
						id: "leftVrSplitter"
					},
					{
						type: LAYOUT_TYPE.PANEL,
						id: "dataExplorer",
						isExpandable: true,
						size: 60,
						arrowPosition: ARROW_POSITION.LEFT,
						toolbarComponent: "dataExplorerToolbar",
						contentComponent: "dataExplorerContent"
					}
				]
			},
			{
				type: LAYOUT_TYPE.SPLITTER,
				id: "leftSplitter"
			},
			{
				type: LAYOUT_TYPE.COLUMN,
				id: "main",
				children: [
					{
						type: LAYOUT_TYPE.PANEL,
						id: "mainContent",
						isExpandable: false,
						toolbarComponent: "mainToolbar",
						secondaryToolbarComponent: "secondaryMainToolbar",
						contentComponent: "mainContent"
					},
					{
						type: LAYOUT_TYPE.SPLITTER,
						id: "consoleSplitter"
					},
					{
						type: LAYOUT_TYPE.TABS,
						id: "panelBottom",
						size: 60,
						arrowPosition: ARROW_POSITION.RIGHT,
						styles: LAYOUT_TABS_STYLE.BUTTON,
						isExpandable: true,
						defaultExpanded: true,
						defaultTabIndex: 0,
						tabs: [
							{
								id: "tester",
								label: "Tester",
								icon: "mdi/stethoscope",
								contentComponent: "tester",
								additionalTabs: "testerRunner"
							},
							{
								id: "references",
								label: "References",
								icon: "mdi/link-variant",
								infoBadge: "referencesCount",
								contentComponent: "references",
							},
							{
								id: "console",
								label: "Issues",
								icon: "mdi/console",
								infoBadge: "consoleCount",
								contentComponent: "console",
								additionalTabs: "consoleFilters"
							}
						]
					}
				]
			},
			{
				type: LAYOUT_TYPE.SPLITTER,
				id: "rightSplitter"
			},
			{
				type: LAYOUT_TYPE.TABS,
				id: "panelRight",
				size: "250px",
				isExpandable: true,
				defaultExpanded: true,
				defaultTabIndex: 0,
				tabs: [
					{
						id: "nodePalette",
						label: "Functions",
						icon: "mdi/toy-brick-plus",
						contentComponent: "nodePalette"
					},
					{
						id: "inspector",
						// label: "Inspect",
						icon: "mdi/tune",
						tooltip: "Inspector",
						contentComponent: "inspector"
					},
					{
						id: "settings",
						icon: "mdi/file-cog",
						tooltip: "Action Settings",
						contentComponent: "settings"
					}
				]
			}
		]
	}
};
